import { createIcon } from '@chakra-ui/icons';

export const GoogleDrive = createIcon({
  displayName: 'GoogleDrive',
  viewBox: '0 0 28 26',
  path: [
    <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7969 8.09003L9.45675 0.430683C9.60085 0.283964 9.76665 0.187729 9.93245 0.123047C8.65257 0.544271 8.06532 1.98148 8.06532 1.98148L0.136616 15.9702C0.0250533 16.4088 -0.00593898 16.8048 0.00800637 17.1535H8.66187L13.7969 8.09003Z"
        fill="#34A853"
      />
      <path
        d="M13.7969 8.09003L18.9319 17.1535H27.5857C27.5997 16.8048 27.5687 16.4088 27.4571 15.9702L19.5284 1.98148C19.5284 1.98148 18.9396 0.544271 17.6613 0.123047C17.8255 0.187729 17.9929 0.283964 18.137 0.430683L13.7969 8.09003Z"
        fill="#FBBC05"
      />
      <path
        d="M13.7971 8.09034L18.1372 0.43099C17.9931 0.284272 17.8258 0.188037 17.6615 0.123354C17.4725 0.061827 17.2695 0.020809 17.0495 0.00976562H16.8202H10.7741H10.5448C10.3263 0.0192313 10.1218 0.0602494 9.93272 0.123354C9.76848 0.188037 9.60113 0.284272 9.45703 0.43099L13.7971 8.09034Z"
        fill="#188038"
      />
      <path
        d="M8.66387 17.1543L4.37335 24.7269C4.37335 24.7269 4.23079 24.6575 4.03711 24.5139C4.64606 24.9825 5.23796 25.0818 5.23796 25.0818H22.0886C23.0183 25.0818 23.212 24.7269 23.212 24.7269C23.2151 24.7253 23.2166 24.7237 23.2197 24.7221L18.9323 17.1543H8.66387Z"
        fill="#4285F4"
      />
      <path
        d="M8.6646 17.1543H0.0107422C0.0541277 18.1829 0.500379 18.784 0.500379 18.784L0.825772 19.3488C0.849014 19.3819 0.862958 19.4008 0.862958 19.4008L1.57107 20.644L3.16084 23.4111C3.20732 23.5231 3.26156 23.6257 3.31889 23.7235C3.34058 23.7566 3.36072 23.7929 3.38396 23.8245C3.39016 23.8339 3.39636 23.8434 3.40256 23.8529C3.59934 24.1305 3.81937 24.3451 4.0394 24.5139C4.23308 24.659 4.37564 24.7269 4.37564 24.7269L8.6646 17.1543Z"
        fill="#1967D2"
      />
      <path
        d="M18.9316 17.1543H27.5855C27.5421 18.1829 27.0959 18.784 27.0959 18.784L26.7705 19.3488C26.7472 19.3819 26.7333 19.4008 26.7333 19.4008L26.0252 20.644L24.4354 23.4111C24.3889 23.5231 24.3347 23.6257 24.2774 23.7235C24.2557 23.7566 24.2355 23.7929 24.2123 23.8245C24.2061 23.8339 24.1999 23.8434 24.1937 23.8529C23.9969 24.1305 23.7769 24.3451 23.5568 24.5139C23.3632 24.659 23.2206 24.7269 23.2206 24.7269L18.9316 17.1543Z"
        fill="#EA4335"
      />
    </svg>,
  ],
});
